import * as React from 'react';
import { useRouter } from 'react-resource-router';

// TODO https://jdog.jira-dev.com/browse/FSD-3964: use more accurate types
export interface InjectedProps {
    portalId?: string | undefined;
    requestTypeId?: string | undefined;
    requestGroupId?: string | undefined;
    categoryId?: string | undefined;
    requestKey?: string | undefined;
    articleId?: string | undefined;
}

const RouteParamContext = React.createContext<InjectedProps>({});

export const PathParamsProvider: React.FunctionComponent<{
    children: React.ReactNode;
    params: InjectedProps;
}> = (props) => <RouteParamContext.Provider value={props.params}>{props.children}</RouteParamContext.Provider>;

const withPathParams =
    <TProps extends InjectedProps>(
        WrappedComponent: React.ComponentType<TProps>
    ): React.FunctionComponent<Omit<TProps, keyof InjectedProps>> =>
    // upgrading eslint-plugin-react to 7.31.11. Please correct when this code is revisited.
    // eslint-disable-next-line react/display-name
    (props: TProps) => (
        <RouteParamContext.Consumer>
            {(value: InjectedProps) => <WrappedComponent {...props} {...value} />}
        </RouteParamContext.Consumer>
    );

export const withPathParamProvider = <P extends object>(
    Component: React.ComponentType<P>
): React.FunctionComponent<P> => {
    // eslint-disable-next-line react/display-name
    return (props: P) => {
        const [{ match }] = useRouter();
        return (
            <PathParamsProvider params={match.params}>
                <Component {...props} />
            </PathParamsProvider>
        );
    };
};

export default withPathParams;
